import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add"}/>
}
